import { render } from "./TextareaField.vue?vue&type=template&id=5a8ceea1"
import script from "./TextareaField.vue?vue&type=script&lang=js"
export * from "./TextareaField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\server\\www\\greativ\\ui\\template\\superSkypark\\moduleTmpl\\roomRent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__